import React from 'react';
import PropTypes from 'prop-types';

import Close from 'icons/Close';
import SnoozeStyled from './SnoozeStyled';
import Delete from './Delete';

class Snooze extends React.PureComponent {
  handleDeleteClick = () => {
    this.props.onDelete(this.props.snooze);
  }

  render() {
    return (
      <SnoozeStyled>
        <div style={{ display: 'inline-block', marginRight: '8px' }}>{this.props.snooze.name}</div>

        {!this.props.disabled && (
          <Delete type="button" onClick={this.handleDeleteClick}>
            <Close />
          </Delete>
        )}
      </SnoozeStyled>
    );
  }
}

Snooze.propTypes = {
  snooze: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onDelete: PropTypes.func,
  disabled: PropTypes.bool,
};

Snooze.defaultProps = {
  onDelete: () => {},
  disabled: false,
};

export default Snooze;
